export class Adresse {
    public strasse?: string = null;
    public hausnummer?: string = null;
    public plz?: string = null;
    public stadt?: string = null;
}
